export default {"src":"/sitetest/_next/static/media/menu_icon.57747802.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};